import styled from 'styled-components'

function BaseKeyboardArrowLeftIcon({ className, size = 24, ...rest }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z" fill="currentColor" />
    </svg>
  )
}

export const KeyboardArrowLeftIcon = styled(BaseKeyboardArrowLeftIcon)`
  flex-shrink: 0;
`
